export const common = {
  product: "Malfak",
  tagline: "Social media, handled.",
  actions: {
    save: "Save",
    saveChanges: "Save changes",
    cancel: "Cancel",
    close: "Close",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    add: "Add",
    remove: "Remove",
    retry: "Try again",
    reload: "Reload",
    back: "Back",
    next: "Next",
    skip: "Skip",
    done: "Done",
    continue: "Continue",
    apply: "Apply",
    reset: "Reset",
    clear: "Clear",
    copy: "Copy",
    copied: "Copied",
    search: "Search",
    filter: "Filter",
    export: "Export",
    exportCsv: "Export CSV",
    viewAll: "View all",
    more: "More",
    open: "Open",
    approve: "Approve",
    reject: "Reject",
    send: "Send",
    reply: "Reply",
    hide: "Hide",
    unhide: "Unhide",
    assign: "Assign",
    markDone: "Done",
    reopen: "Reopen",
    regenerate: "Regenerate",
    insert: "Insert",
    generate: "Generate",
    upload: "Upload",
    connect: "Connect",
    disconnect: "Disconnect",
    schedule: "Schedule",
    publishNow: "Publish now",
    learnMore: "Learn more",
    selectAll: "Select all",
    deselect: "Clear selection",
    undo: "Undo",
  },
  states: {
    loading: "Loading…",
    saving: "Saving…",
    saved: "Saved",
    error: "Something went wrong",
    errorHint: "We couldn't load this. Check your connection and try again.",
    empty: "Nothing here yet",
    offline: "You're offline. Changes will sync when you're back.",
    backOnline: "Back online",
    notFound: "Not found",
    comingSoon: "Coming soon",
    beta: "Beta",
    new: "New",
    on: "On",
    off: "Off",
    all: "All",
    none: "None",
    unknown: "Unknown",
    you: "You",
    requestId: "Request id",
  },
  noOrg: {
    title: "You're not part of an organization yet",
    hint: "Create your organization to continue. You'll be its owner.",
    create: "Create organization",
  },
  errors: {
    network: "Can't reach Malfak. Check your connection.",
    unauthorized: "Your session ended. Please sign in again.",
    forbidden: "You don't have permission to do that.",
    notFound: "That item no longer exists.",
    rateLimited: "Too many requests. Wait a moment and retry.",
    validation: "Some fields need attention.",
    server: "The server had a problem. We've been notified.",
    boundaryTitle: "This screen ran into a problem",
    boundaryHint: "The rest of Malfak still works. Try again, or go back home.",
    notFoundTitle: "This page doesn't exist",
    notFoundHint: "The link may be broken, or the page may have moved.",
    goHome: "Go home",
  },
  channels: {
    instagram: "Instagram",
    facebook_page: "Facebook Page",
    messenger: "Messenger",
    whatsapp: "WhatsApp",
    threads: "Threads",
    tiktok: "TikTok",
  },
  accountStatus: {
    active: "Active",
    needs_reauth: "Needs reconnect",
    disconnected: "Disconnected",
    syncing: "Syncing",
  },
  intents: {
    question: "Question",
    price: "Price",
    purchase: "Purchase",
    collab: "Collab",
    complaint: "Complaint",
    praise: "Praise",
    spam: "Spam",
    hate: "Hate",
    other: "Other",
  },
  sentiments: {
    positive: "Positive",
    neutral: "Neutral",
    negative: "Negative",
  },
  inboxStates: {
    open: "Open",
    done: "Done",
    snoozed: "Snoozed",
  },
  roles: {
    owner: "Owner",
    admin: "Admin",
    editor: "Editor",
    viewer: "Viewer",
  },
  postTypes: {
    image: "Image",
    video: "Video",
    carousel: "Carousel",
    reel: "Reel",
    story: "Story",
    text: "Text",
  },
  postStatus: {
    draft: "Draft",
    in_review: "In review",
    approved: "Approved",
    scheduled: "Scheduled",
    publishing: "Publishing",
    published: "Published",
    partially_published: "Partly published",
    failed: "Failed",
    cancelled: "Cancelled",
  },
  metrics: {
    reach: "Reach",
    views: "Views",
    accounts_engaged: "Accounts engaged",
    total_interactions: "Interactions",
    likes: "Likes",
    comments: "Comments",
    shares: "Shares",
    saves: "Saves",
    saved: "Saves",
    followers: "Followers",
    follower_count: "Followers",
    profile_views: "Profile views",
    engagement: "Engagement",
    engagementRate: "Engagement rate",
  },
  time: {
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    thisWeek: "This week",
    last7: "Last 7 days",
    last28: "Last 28 days",
    last90: "Last 90 days",
    days_one: "{{count}} day",
    days_other: "{{count}} days",
    vsPrevious: "vs previous period",
    now: "Now",
  },
  weekdays: {
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
  },
  a11y: {
    openMenu: "Open menu",
    closeMenu: "Close menu",
    collapseNav: "Collapse sidebar",
    expandNav: "Expand sidebar",
    skipToContent: "Skip to content",
    loading: "Loading",
    selected: "Selected",
    notifications: "Notifications",
    userMenu: "Account menu",
    dismiss: "Dismiss",
  },
  confirm: {
    title: "Are you sure?",
    deleteTitle: "Delete this?",
    irreversible: "This can't be undone.",
  },
  ai: {
    label: "AI",
    poweredBy: "AI-assisted",
    thinking: "Thinking…",
    drafted: "Drafted by AI",
    confidence: "Confidence",
  },
  /** Why an outbound send / job failed, one line per stable error code (ALP-77, contracts OPERATION_ERROR_CODES). */
  sendError: {
    notSent: "Not sent: {{reason}}",
    retry: "Retry",
    retrying: "Sending again…",
    codes: {
      channel_reauth_required: "Instagram needs to be reconnected",
      messaging_window_closed: "The 24-hour window is closed: the customer must message first",
      rate_limited: "Sending failed",
      provider_error: "Sending failed",
      unknown: "Sending failed",
      validation: "Instagram rejected the content (too long, or an invalid link or attachment)",
      capability_not_supported: "This channel can't do that",
      forbidden: "Instagram didn't allow this action for the account",
      not_found: "It no longer exists on Instagram (deleted or unavailable)",
      outbound_disabled: "Sending is switched off by the platform administrator",
      conflict: "This was already done or changed in the meantime",
      limit_reached: "Your plan limit is reached for this period",
      feature_not_in_plan: "Your plan doesn't include this feature",
      ai_unavailable: "The AI service is unavailable right now",
      budget_exceeded: "AI budget for this month is used up",
      storage_error: "The result couldn't be saved (storage error)",
      content_policy: "The AI provider refused this request (content policy)",
      timeout: "It took too long and was stopped",
    },
  },
  /** A 0..1 score in words (lib/format scoreLevel): customers never see "0.93". */
  level: { low: "Low", medium: "Medium", high: "High", unknown: "Not rated" },
  /** The collapsed, staff-only "Technical details" disclosure (components/ui/technical-details). */
  technical: { title: "Technical details", hint: "Only Malfak staff see this." },
};
